import React from 'react';
import SvgIcon from './SvgIcon';

const AddTelephone = props => {
    return (
        <SvgIcon viewBox="0 0 26 24" fill="none" {...props}>
            <path
                d="M18.353 12C19.975 9.76 21 7.497 21 5.522c0-3.004-2.436-4.372-3.37-4.505-.935-.134-1.335.567-1.636 1l-2.27 3.472a1.602 1.602 0 00.435 2.169c.967.8 2.536 1.802-1.102 5.44-3.637 3.637-4.605 2.035-5.406 1.067a1.602 1.602 0 00-2.169-.434l-3.47 2.27c-.435.3-1.102 1-1.002 1.668.1.668 1.535 3.337 4.505 3.337 2.551 0 5.619-1.723 8.485-4.26M22.25 17.625H17M19.625 15v5.25V15z"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.625 23.25a5.625 5.625 0 100-11.25 5.625 5.625 0 000 11.25z"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

AddTelephone.displayName = 'AddTelephoneIcon';

export default AddTelephone;
